import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import RecoveryPhrase from './RecoveryPhrase';
import LinkDevice from './LinkDevice';
import LiveChat from './LiveChat';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/recovery" element={<RecoveryPhrase />} />
        <Route path="/link-device" element={<LinkDevice />} />
      </Routes>
      <LiveChat />
    </Router>
  );
}

export default App; 